export function GetShortenText(text: string) {
  if (text.length > 20) {
    text = text.substring(0, 20) + "...";
  }
  return text;
}

export const convertDate = (date: Date) => {
  if (date) {
    return new Date(date).toLocaleDateString("en-us", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
};

export function formatDateToDDMMYYYY(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
